// import { POST_ENC } from "./common/EncryptedHttp";
// import { BASE_URL } from "./common/const";

// export const GetWhatsappStatus = (data: any) =>
//     POST_ENC(`${BASE_URL}/api/Whatsapp/status`, data);

// export const SendWhatsappMessage = (data: any) =>
//     POST_ENC(`${BASE_URL}/api/Whatsapp/send`, data);

import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

const BASE = `${BASE_URL}/api/Whatsapp`;

// ── Existing ──────────────────────────────────────────────
export const GetWhatsappStatus = (data: any) =>
  POST_ENC(`${BASE}/status`, data);
export const SendWhatsappMessage = (data: any) =>
  POST_ENC(`${BASE}/send`, data);

// ── Module Config ─────────────────────────────────────────
export const GetWhatsappModuleConfig = (data: any) =>
  POST_ENC(`${BASE}/module/config`, data);
export const SetupWhatsappModule = (data: any) =>
  POST_ENC(`${BASE}/module/setup`, data);
export const SwitchWhatsappModule = (data: any) =>
  POST_ENC(`${BASE}/module/switch`, data);

// ── Credentials (CLINIC_API) ──────────────────────────────
export const SaveWhatsappCredentials = (data: any) =>
  POST_ENC(`${BASE}/credentials/save`, data);
export const ValidateWhatsappConnection = (data: any) =>
  POST_ENC(`${BASE}/credentials/validate`, data);

// ── Manual Module ─────────────────────────────────────────
export const ManualConnectWhatsapp = (data: any) =>
  POST_ENC(`${BASE}/manual/connect`, data);
export const ManualGetQR = (data: any) => POST_ENC(`${BASE}/manual/qr`, data);
export const ManualGetStatus = (data: any) =>
  POST_ENC(`${BASE}/manual/connectionstatus`, data);
export const ManualDisconnect = (data: any) =>
  POST_ENC(`${BASE}/manual/disconnect`, data);

// ── Send ──────────────────────────────────────────────────
export const SendSingleMessage = (data: any) =>
  POST_ENC(`${BASE}/send/single`, data);
export const SendTemplateMessage = (data: any) =>
  POST_ENC(`${BASE}/send/template`, data);
export const SendBulkCampaign = (data: any) =>
  POST_ENC(`${BASE}/send/bulk`, data);

// ── Campaigns ─────────────────────────────────────────────
export const GetCampaigns = (data: any) =>
  POST_ENC(`${BASE}/campaigns/list`, data);
export const CampaignAction = (data: any) =>
  POST_ENC(`${BASE}/campaigns/action`, data);

// ── Contacts ──────────────────────────────────────────────
export const GetContacts = (data: any) =>
  POST_ENC(`${BASE}/contacts/list`, data);
export const SaveContact = (data: any) =>
  POST_ENC(`${BASE}/contacts/save`, data);
export const DeleteContact = (data: any) =>
  POST_ENC(`${BASE}/contacts/delete`, data);
export const OptOutContact = (data: any) =>
  POST_ENC(`${BASE}/contacts/optout`, data);

// ── Templates ─────────────────────────────────────────────
export const GetTemplates = (data: any) =>
  POST_ENC(`${BASE}/templates/list`, data);
export const SaveTemplate = (data: any) =>
  POST_ENC(`${BASE}/templates/save`, data);
export const DeleteTemplate = (data: any) =>
  POST_ENC(`${BASE}/templates/delete`, data);

// ── Credits (VISTAMED) ────────────────────────────────────
export const GetCreditBalance = (params: any) =>
  GET_ENC(`${BASE}/credits/balance?` + params, null);
export const PurchaseCredits = (data: any) =>
  POST_ENC(`${BASE}/credits/purchase`, data);
export const GetCreditHistory = (data: any) =>
  POST_ENC(`${BASE}/credits/history`, data);

// ── Message Log ───────────────────────────────────────────
export const GetMessages = (data: any) =>
  POST_ENC(`${BASE}/messages/list`, data);

// ── Bulk Queue — NEW ──────────────────────────────────────
export const BulkQueueSubmit = (data: any) =>
  POST_ENC(`${BASE}/bulk-queue/submit`, data);
export const BulkQueueStatus = (params: {
  batchId?: string;
  branchId?: number;
}) =>
  GET_ENC(
    `${BASE}/bulk-queue/status?batchId=${params.batchId ?? ""}&branchId=${params.branchId ?? ""}`,
  );
export const BulkQueueCancel = (data: any) =>
  POST_ENC(`${BASE}/bulk-queue/cancel`, data);
